import './styles/style.css'; // Import the global styles

// Dynamically load page-specific JavaScript
document.addEventListener('DOMContentLoaded', () => {
    const pathname = window.location.pathname;

    if (pathname === '/login') {
        import('./login.js').then(({ default: loginScript }) => {
            loginScript(); // Initialize the login script
        });
    }

    if(pathname === '/export') {
        import('./export.js').then(({ default: exportScript }) => {
            exportScript(); // Initialize the export script
        });
    }

    if(pathname === '/export-all') {
        import('./export-all.js').then(({ default: exportAllScript }) => {
            exportAllScript(); // Initialize the export script
        });
    }

    console.log('Global JS loaded');
});